import putFileToPresignedUrl from "@/utils/putFileToPresignedUrl";
import { MESSAGING_HTTP_BASE } from "@/config/messaging";
const MAX_BYTES = 10 * 1024 * 1024;
export const requestChatPutUrl = async (params) => {
    const res = await fetch(`${MESSAGING_HTTP_BASE.replace(/\/$/, "")}?op=puturl`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: params.authToken,
        },
        body: JSON.stringify({
            conversationId: params.conversationId,
            fileName: params.fileName,
            contentType: params.contentType,
            size: params.size,
        }),
    });
    const text = await res.text();
    const body = text ? JSON.parse(text) : {};
    if (!res.ok) {
        throw new Error(String(body.error || body.message || `Error al solicitar URL (${res.status})`));
    }
    if (!body.url || !body.key)
        throw new Error("Respuesta puturl incompleta");
    return {
        url: String(body.url),
        key: String(body.key),
        contentType: String(body.contentType || params.contentType),
    };
};
export const uploadChatAttachment = async (params) => {
    if (params.file.size > MAX_BYTES) {
        throw new Error("El archivo supera el máximo de 10 MB");
    }
    const fileName = params.file.name || `adjunto-${Date.now()}.bin`;
    const contentType = params.file.type || "application/octet-stream";
    const { url, key, contentType: signedType } = await requestChatPutUrl({
        conversationId: params.conversationId,
        fileName,
        contentType,
        size: params.file.size,
        authToken: params.authToken,
    });
    const result = await putFileToPresignedUrl(url, params.file, signedType || contentType, params.onProgress);
    if (!result.ok) {
        throw new Error(`Error al subir archivo (${result.status})`);
    }
    return {
        key,
        fileName,
        contentType: signedType || contentType,
        size: params.file.size,
    };
};
